import React, { useState } from 'react';
import { hasDecided, giveConsent, declineConsent } from '../../../services/analytics';
import './CookieConsentBanner.css';

const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(!hasDecided());

  if (!visible) return null;

  const handleAccept = () => {
    giveConsent();
    setVisible(false);
  };

  const handleDecline = () => {
    declineConsent();
    setVisible(false);
  };

  return (
    <div className="cookie-banner">
      <div className="cookie-banner__content">
        <p className="cookie-banner__text">
          We use cookies to understand how you use our site and improve your experience.
          No personal data is shared with third parties.
        </p>
        <div className="cookie-banner__actions">
          <button className="cookie-banner__btn cookie-banner__btn--accept" onClick={handleAccept}>
            Accept
          </button>
          <button className="cookie-banner__btn cookie-banner__btn--decline" onClick={handleDecline}>
            Decline
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
